import {Trans} from '@lingui/macro';
import React, {ReactNode} from 'react';
import styled from 'styled-components';

import {Handler} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {ButtonVariantsEnum} from '../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {OkCancelDialog} from '../../../components/common/dialogs/okCancelDialog';

/*
 * Props.
 */

interface ResourceDeleteDialogProps<T extends {id: unknown}> {
  items: ReadonlyArray<T>;
  selectedIds: ReadonlyArray<T['id']>;
  onClose: Handler;
  onDelete: Handler;

  renderDeleteItemsTitle: (count: number, item: T | undefined) => ReactNode;
  renderDeleteItemsDescription: (count: number) => ReactNode;
}

/*
 * Styles.
 */

const StyledOkCancelDialog = styled(OkCancelDialog)`
  margin: 0 16px;
`;

/*
 * Component.
 */

export const ResourceDeleteDialog = <T extends {id: unknown}>(props: ResourceDeleteDialogProps<T>) => {
  const {items, selectedIds, onClose, onDelete, renderDeleteItemsTitle, renderDeleteItemsDescription} = props;

  const firstItem = items.find((i) => selectedIds[0] === i.id);

  return (
    <StyledOkCancelDialog
      title={renderDeleteItemsTitle(selectedIds.length, firstItem)}
      okButtonLabel={<Trans id="delete-confirmation-dialog-delete-permanently">Delete permanently</Trans>}
      okButtonVariant={ButtonVariantsEnum.DANGER}
      onRequestClose={onClose}
      onOkClick={onDelete}
    >
      {renderDeleteItemsDescription(selectedIds.length)}
    </StyledOkCancelDialog>
  );
};
